/*

	NOTICE!
	This file was generated automatically
	This is not code!

*/

import { EventType } from 'Utility/Helpers/Events/EventType';
import { PopupID } from 'State/UI/PopupID';
import { ChristmasOfferLayout } from 'Layouts/Events/xmas_2021/eventOfferPopup/ChristmasOfferLayout';
import { EventFieldHarvestLayout } from 'Layouts/Events/xmas_2021/fieldHarvestMenu/EventFieldHarvestLayout';
import { EventLevelCompletePopupLayout } from 'Layouts/Events/xmas_2021/levelCompletePopup/EventLevelCompletePopupLayout';
import { EventLevelPopupLayout } from 'Layouts/Events/xmas_2021/levelPopup/EventLevelPopupLayout';
import { EventLevelPopupSideMenuLayout } from 'Layouts/Events/xmas_2021/levelPopupSideMenu/EventLevelPopupSideMenuLayout';
import { EventQuestsPopupLayout } from 'Layouts/Events/xmas_2021/questsMenu/EventQuestsPopupLayout';

export const EventLayoutMap: Record<EventType, Partial<{[key in PopupID]: any}>> = {
['xmas_2021']: {

['eventOfferPopup']: ChristmasOfferLayout,
['fieldHarvestMenu']: EventFieldHarvestLayout,
['levelCompletePopup']: EventLevelCompletePopupLayout,
['levelPopup']: EventLevelPopupLayout,
['levelPopupSideMenu']: EventLevelPopupSideMenuLayout,
['questsMenu']: EventQuestsPopupLayout,
}
,
}
